<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="模板类型：">
            <el-select style="width: 150px;" v-model="formInline.type" filterable placeholder="请选择">
                <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="模板状态：">
            <el-select style="width: 150px;" v-model="formInline.state" filterable placeholder="请选择">
                <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="模板用途：">
            <el-select style="width: 150px;" v-model="formInline.usage" filterable placeholder="请选择">
                <el-option
                v-for="item in useOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button type="primary" @click="openAdd">新增模板</el-button>
        </el-form-item>
    </el-form>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="模板名称" min-width="300" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="模板类型">
        <template #default="scope">
          <div>
            <span>{{typeFilter(scope.row.type)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="160" label="模板状态">
        <template #default="scope">
          <div>
            <span>{{stateFilter(scope.row.state)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="模板用途">
        <template #default="scope">
          <div>
            <span>{{usageFilter(scope.row.usage)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="使用数量" width="100">
        <template #default="scope">
          <div>
            <span>{{scope.row.useCount}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="200">
        <template #default="scope">
          <div>
            <span>{{scope.row.createTime}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" min-width="200">
        <template #default="scope">
          <div>
            <span>{{scope.row.updateTime}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="210" fixed="right">
        <template #default="scope">
          <el-button v-if="scope.row.state==1" type="primary" size="small" @click="updateTemplate(scope.$index, scope.row)">
            修改
          </el-button>
          <el-button type="success" size="small" @click="showInfo(scope.$index, scope.row)">
            详情
          </el-button>
          <el-button v-if="scope.row.state==1" type="danger" size="small" @click="changeState(scope.$index, scope.row)">
            废弃
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 添加、编辑模板 -->
    <el-drawer
        v-model="drawer"
        :title="e_title"
        direction="rtl"
        size="90%"
        :before-close="handleClose"
        @closed="$refs.templateFormRef?.clearValidate()"
    >
    <el-form ref="templateFormRef" :model="TemplateData" :rules="templateRules" label-position="right" label-width="auto">
        <el-row :gutter="20" style="margin-bottom: 20px;">
          <el-col :span="8">
            <el-form-item label="模板类型：">
              <el-radio-group v-model="TemplateData.type" size="large" fill="#6cf" @change="changeType">
                <el-radio-button label="全天统一价" :value="1" />
                <el-radio-button label="分段计费" :value="2" />
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="模板名称：" prop="name">
              <el-input v-model="TemplateData.name" maxlength="30" autocomplete="off" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="模板用途：" prop="">
              <el-radio-group v-model="TemplateData.usage">
                <el-radio :value="1">公共模板</el-radio>
                <el-radio :value="2">私有模板</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="TemplateData.type==1" :gutter="20" style="margin-bottom: 20px;">
          <el-col :span="8">
            <el-form-item label="电价(元/度)：" prop="">
              <el-input style="width: 150px;" v-model="TemplateData.unityPrice.electricityPrice" autocomplete="off" placeholder="请输入电价" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务费(元/度)：" prop="">
              <el-input style="width: 150px;" v-model="TemplateData.unityPrice.servicePrice" autocomplete="off" placeholder="请输入服务费" />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="model_nav" v-if="TemplateData.type==1 || TemplateData.type==2">
          <div class="model_item" v-for="(item,index) in TemplateData.rules">
            <el-form :inline="true">
                <el-form-item label="" prop="">
                  <div style="font-size: 22px;color: #999;">{{periodFilter(item.period)}}</div>
                </el-form-item>
                <el-form-item v-if="TemplateData.type==2" label="电价(元/度)：" prop="">
                  <el-input style="width: 100px;" v-model="item.electricityPrice" autocomplete="off" placeholder="数字" />
                </el-form-item>
                <el-form-item v-if="TemplateData.type==2" label="服务费(元/度)：" prop="">
                  <el-input style="width: 100px;" v-model="item.servicePrice" autocomplete="off" placeholder="数字" />
                </el-form-item>
            </el-form>
            <div class="item_nav">
              <div class="item_left">
                <div style="margin: 10px 0;font-weight: bold;">配置时间段：</div>
                <el-button class="add_time_btn" type="primary" @click="addTime(index)">添加</el-button>
                <el-form>
                    <el-form-item label="开始时刻：" prop="">
                      <el-time-select
                          v-model="item.beginTime"
                          style="width: 150px"
                          :max-time="item.endTime"
                          format="HH:mm"
                          @change="changeBeginTime(index)"
                          placeholder="开始时刻"
                          start="00:00"
                          step="00:30"
                          end="24:00"
                        />
                    </el-form-item>
                </el-form>
                <el-form>
                    <el-form-item label="结束时刻：" prop="">
                      <el-time-select
                          v-model="item.endTime"
                          style="width: 150px"
                          :min-time="item.beginTime"
                          format="HH:mm"
                          placeholder="结束时刻"
                          @change="changeEndTime(index)"
                          start="00:29"
                          step="00:30"
                          end="23:59"
                        />
                    </el-form-item>
                </el-form>
              </div>
              <div class="item_right">
                <div style="margin: 10px 0;font-weight: bold;">已配置时间段：</div>
                <div v-for="(item2,index2) in paramRules">
                  <div v-if="item2.period==item.period">
                    <span>{{item2.beginTime}}-{{item2.endTime}} 电价 ￥{{ item2.electricityPrice }} 服务费 ￥{{ item2.servicePrice }}</span>
                    <el-icon style="margin-left: 5px;position: relative;top: 2px;color: #df2323;" @click="deleteTime(index2)"><CircleCloseFilled /></el-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 时段配置可视化 -->
        <div class="time-visualization" v-if="TemplateData.type==1 || TemplateData.type==2">
          <div class="viz-header">
            <span class="viz-title">时段配置可视化</span>
            <el-button type="danger" size="small" @click="clearAllConfig">清空配置</el-button>
          </div>
          <div class="time-blocks">
            <div 
              v-for="slot in 48" 
              :key="slot-1" 
              class="time-block"
              :class="getTimeSlotClass(slot-1)"
              :title="getTimeSlotTitle(slot-1)"
            >
            </div>
          </div>
          <div class="time-labels">
            <div 
              v-for="hour in 24" 
              :key="hour-1" 
              class="hour-label-item"
            >
              <span>{{ hour-1 }}时</span>
            </div>
          </div>
          <div class="time-legend">
            <div class="legend-item">
              <span class="legend-color legend-sharp"></span>
              <span>尖时</span>
            </div>
            <div class="legend-item">
              <span class="legend-color legend-peak"></span>
              <span>峰时</span>
            </div>
            <div class="legend-item">
              <span class="legend-color legend-flat"></span>
              <span>平时</span>
            </div>
            <div class="legend-item">
              <span class="legend-color legend-valley"></span>
              <span>谷时</span>
            </div>
            <div class="legend-item">
              <span class="legend-color legend-unconfigured"></span>
              <span>未配置</span>
            </div>
          </div>
        </div>

  </el-form>
       <template #footer>
        <div class="dialog-footer">
            <el-button @click="closeAdd">取消</el-button>
            <el-button type="primary" @click="save()">确定</el-button>
        </div>
        </template>
    </el-drawer>

    <!-- 详情 -->
    <el-dialog v-model="showDetail" title="模板详情" width="800" :close-on-click-modal="false">
      <el-form :model="TemplateInfo" label-position="right" label-width="auto">
        <el-form :inline="true">
          <el-form-item label="模板名称：" prop="">
            <div>{{TemplateInfo.name}}</div>
          </el-form-item>
          <el-form-item label="模板类型：" prop="">
            <div>
              <span>{{typeFilter(TemplateInfo.type)}}</span>
            </div>
          </el-form-item>
          <el-form-item label="模板状态：" prop="">
            <div>
              <span>{{stateFilter(TemplateInfo.state)}}</span>
            </div>
          </el-form-item>
          <el-form-item label="模板用途：" prop="">
            <div>
              <span>{{usageFilter(TemplateInfo.usage)}}</span>
            </div>
          </el-form-item>
        </el-form>
        <el-form :inline="true" v-for="(item,index) in TemplateInfo.periodList1">
          <el-form-item label="尖时：" prop="">
            <div class="form_item_nav">
              <div class="form_item">{{item.beginTime}}-{{item.endTime}}</div>
            </div>
          </el-form-item>
          <el-form-item label="电价(元/度)：" prop="">
            <div>￥{{item.electricityPrice}}</div>
          </el-form-item>
          <el-form-item label="服务费价格(元/度)：" prop="">
            <div>￥{{item.servicePrice}}</div>
          </el-form-item>
        </el-form>
        <el-form :inline="true" v-for="(item,index) in TemplateInfo.periodList2">
          <el-form-item label="峰时：" prop="">
            <div class="form_item_nav">
              <div class="form_item">{{item.beginTime}}-{{item.endTime}}</div>
            </div>
          </el-form-item>
          <el-form-item label="电价(元/度)：" prop="">
            <div>￥{{item.electricityPrice}}</div>
          </el-form-item>
          <el-form-item label="服务费价格(元/度)：" prop="">
            <div>￥{{item.servicePrice}}</div>
          </el-form-item>
        </el-form>
        <el-form :inline="true" v-for="(item,index) in TemplateInfo.periodList3">
          <el-form-item label="平时：" prop="">
            <div class="form_item_nav">
              <div class="form_item">{{item.beginTime}}-{{item.endTime}}</div>
            </div>
          </el-form-item>
          <el-form-item label="电价(元/度)：" prop="">
            <div>￥{{item.electricityPrice}}</div>
          </el-form-item>
          <el-form-item label="服务费价格(元/度)：" prop="">
            <div>￥{{item.servicePrice}}</div>
          </el-form-item>
        </el-form>
        <el-form :inline="true" v-for="(item,index) in TemplateInfo.periodList4">
          <el-form-item label="谷时：" prop="">
            <div class="form_item_nav">
              <div class="form_item">{{item.beginTime}}-{{item.endTime}}</div>
            </div>
          </el-form-item>
          <el-form-item label="电价(元/度)：" prop="">
            <div>￥{{item.electricityPrice}}</div>
          </el-form-item>
          <el-form-item label="服务费价格(元/度)：" prop="">
            <div>￥{{item.servicePrice}}</div>
          </el-form-item>
        </el-form>

      </el-form>
    </el-dialog>

</template>

<script>
import { ElMessage } from 'element-plus';
import { required, isPrice, isPriceValue, noSpecialChar } from '@/utils/validators';
    export default {
        name:'ChargeTemplate',
        data() {
            return {
              templateFormRef: null,
              templateRules: {
                name: [required('请输入模板名称')],
              },
              TemplateData:{
                name:'',
                type: 2,
                usage: 1,
                unityPrice: {
                  electricityPrice: '',
                  servicePrice: ''
                },
                unityRules: [  //普通模板
                    {
                      "beginTime": '00:00:00',
                      "createTime": null,
                      "deleteFlag": 0,
                      "electricityPrice": null,
                      "endTime": '23:59:59',
                      "period": null,
                      "servicePrice": null,
                      "templateId": null,
                      "updateTime": null
                    } 
                ],
                rules: [  //分段模板
                    {
                      "beginTime": null,
                      "createTime": null,
                      "deleteFlag": 0,
                      "electricityPrice": 0,
                      "endTime": null,
                      "period": 1,
                      "servicePrice": 0,
                      "templateId": 0,
                      "updateTime": null
                    },
                    {
                      "beginTime": null,
                      "createTime": null,
                      "deleteFlag": 0,
                      "electricityPrice": 0,
                      "endTime": null,
                      "period": 2,
                      "servicePrice": 0,
                      "templateId": 0,
                      "updateTime": null
                    },
                    {
                      "beginTime": null,
                      "createTime": null,
                      "deleteFlag": 0,
                      "electricityPrice": 0,
                      "endTime": null,
                      "period": 3,
                      "servicePrice": 0,
                      "templateId": 0,
                      "updateTime": null
                    },
                    {
                      "beginTime": null,
                      "createTime": null,
                      "deleteFlag": 0,
                      "electricityPrice": 0,
                      "endTime": null,
                      "period": 4,
                      "servicePrice": 0,
                      "templateId": 0,
                      "updateTime": null
                    }
                ]
              },
              TemplateInfo:{},//模板详情
              paramRules:[],//配置时间段
              drawer: false,
              showDetail: false, // 详情
              e_title: '',
              isUpdate: false, //是否修改
              formInline: {
                  usage: '',
                  type: '',
                  state: '',
              },
              typeOptions: [
                  {
                      value: '',
                      name: '全部' 
                  },
                  {
                      value: '1',
                      name: '全天统一价' 
                  },
                  {
                      value: '2',
                      name: '分段计费'  
                  }
              ], // 模板类型
              stateOptions: [
                  {
                      value: '',
                      label: '全部' 
                  },
                  {
                      value: '1',
                      label: '正常' 
                  },
                  {
                      value: '2',
                      label: '废弃'
                  }
              ], // 模板状态
              useOptions: [
                  {
                      value: '',
                      label: '全部' 
                  },
                  {
                      value: '1',
                      label: '公共模板' 
                  },
                  {
                      value: '2',
                      label: '私有模板'
                  }
              ], // 模板用途
              tableData: [
                  // {
                  //     name: '模板1',
                  //     type: '1',
                  //     state: '1',
                  //     use: '1',
                  //     num: '10',
                  //     createTime: '2024-06-14 10:00:00',
                  //     updateTime: '2024-06-14 10:00:00'
                  // }
              ], // 列表数据
              total: 0, //总条数
              currentPage: 1, //当前页
              pageSize: 10, //每页显示条数
            }
        }, 
        mounted() {
            this.getList(); //获取列表 
        },
        methods:{
          handleSizeChange (val) { //每页显示条数
              this.pageSize = val;
              this.currentPage = 1;
              this.getList();
          },
          handleCurrentChange(val) { //当前页
              this.currentPage = val;
              this.getList(); //获取列表
          },
          clearAllConfig(){
            // 清空所有已配置的时段
            this.TemplateData.rules.forEach(rule => {
              rule.beginTime = null;
              rule.endTime = null;
              if(this.TemplateData.type == 2){
                rule.electricityPrice = 0;
                rule.servicePrice = 0;
              }
            });
            this.paramRules = [];
            ElMessage.success('已清空所有配置');
          },
          getTimeSlotClass(slotIndex){
            // 根据30分钟时间段索引获取对应的时段样式类
            // slotIndex: 0-47，对应 00:00-00:29, 00:30-00:59, 01:00-01:29, ...
            const hour = Math.floor(slotIndex / 2);
            const isSecondHalf = slotIndex % 2 === 1;
            
            const beginMinutes = isSecondHalf ? 30 : 0;
            const endMinutes = isSecondHalf ? 59 : 29;
            
            const beginTime = `${String(hour).padStart(2, '0')}:${String(beginMinutes).padStart(2, '0')}:00`;
            const endTime = `${String(hour).padStart(2, '0')}:${String(endMinutes).padStart(2, '0')}:59`;
            
            for(let rule of this.paramRules){
              if(rule.beginTime && rule.endTime){
                // 判断该30分钟时间段是否在配置的时段内
                if(beginTime >= rule.beginTime && endTime <= rule.endTime){
                  return `hour-period-${rule.period}`;
                }
              }
            }
            return 'hour-unconfigured';
          },
          getTimeSlotTitle(slotIndex){
            // 获取30分钟时间段的提示文本
            const hour = Math.floor(slotIndex / 2);
            const isSecondHalf = slotIndex % 2 === 1;
            const beginMinutes = isSecondHalf ? 30 : 0;
            const endMinutes = isSecondHalf ? 59 : 29;
            
            const timeSlotClass = this.getTimeSlotClass(slotIndex);
            const periodMap = {
              'hour-period-1': '尖时',
              'hour-period-2': '峰时',
              'hour-period-3': '平时',
              'hour-period-4': '谷时',
              'hour-unconfigured': '未配置'
            };
            
            return `${String(hour).padStart(2, '0')}:${String(beginMinutes).padStart(2, '0')}-${String(hour).padStart(2, '0')}:${String(endMinutes).padStart(2, '0')} - ${periodMap[timeSlotClass] || '未配置'}`;
          },
          getTimeSlotLabel(slotIndex){
            // 获取30分钟时间段的显示标签
            const hour = Math.floor(slotIndex / 2);
            const isSecondHalf = slotIndex % 2 === 1;
            const minutes = isSecondHalf ? '30' : '00';
            return `${String(hour).padStart(2, '0')}:${minutes}`;
          },
          checkTime(beginTime,endTime){
            // 校验时间段是否已被包含或重叠
            for(let i=0;i<this.paramRules.length;i++){
              if((this.paramRules[i].beginTime <= beginTime && this.paramRules[i].endTime >= beginTime) ||
                 (this.paramRules[i].beginTime <= endTime && this.paramRules[i].endTime >= endTime)){
                ElMessage.error('该时间段已被包含或重叠');
                return false;
              }
            }
            return true;
          },
          addTime(index){
            // 添加时间段
            var dataInfo = this.TemplateData.rules[index];
            // 全天统一价类型，使用统一价格
            if(this.TemplateData.type == 1){
              if(this.TemplateData.unityPrice.electricityPrice === '' || this.TemplateData.unityPrice.servicePrice === ''){
                ElMessage.error('请先填写统一电价和服务费');
                return false;
              }
              if(!isPriceValue(this.TemplateData.unityPrice.electricityPrice)){
                ElMessage.error('电价只能输入数字');
                return false;
              }
              if(!isPriceValue(this.TemplateData.unityPrice.servicePrice)){
                ElMessage.error('服务费只能输入数字');
                return false;
              }
              dataInfo.electricityPrice = this.TemplateData.unityPrice.electricityPrice;
              dataInfo.servicePrice = this.TemplateData.unityPrice.servicePrice;
            } else {
              // 分段计费类型，校验各时段价格
              if(dataInfo.electricityPrice === '' || dataInfo.servicePrice === ''){
                ElMessage.error('请填写完整电价和服务费');
                return false;
              }
              if(!isPriceValue(dataInfo.electricityPrice)){
                ElMessage.error('电价只能输入数字');
                return false;
              }
              if(!isPriceValue(dataInfo.servicePrice)){
                ElMessage.error('服务费只能输入数字');
                return false;
              }
            }
            if(dataInfo.beginTime && dataInfo.endTime){
              // dataInfo.beginTime = dataInfo.beginTime+':00';
              // dataInfo.endTime = dataInfo.endTime+':59';
            }else{
              ElMessage.error('请选择时间段'); 
              return false;
            }
            // 校验时间段是否已存在
            if(!this.checkTime(dataInfo.beginTime,dataInfo.endTime)){
              return false;
            }
            // 校验通过
            this.paramRules.push(JSON.parse(JSON.stringify(dataInfo)));
          },
          changeBeginTime(index){
            // 开始时间改变
            var dataInfo = this.TemplateData.rules[index];
            if(dataInfo.beginTime){
              dataInfo.beginTime = dataInfo.beginTime +':00';
            }
          },
          changeEndTime(index){
            // 结束时间改变
            var dataInfo = this.TemplateData.rules[index];
            if(dataInfo.endTime){
              dataInfo.endTime = dataInfo.endTime +':59';
            }
          },
          deleteTime(index){
            // 删除时间段 
            this.paramRules.splice(index,1);
          },
          showInfo(index,row){
            // 详情
            this.$axios.post("platform-server/charge/template/view/"+row.id).then(result => {
                if(result.code==200){
                  this.TemplateInfo = result.data;
                  this.showDetail = true; 
                  this.TemplateInfo.periodList1 = [];
                  this.TemplateInfo.periodList2 = [];
                  this.TemplateInfo.periodList3 = [];
                  this.TemplateInfo.periodList4 = [];
                  this.TemplateInfo.rules.forEach(item => {
                    if(item.period==1){
                      this.TemplateInfo.periodList1.push(item); 
                    } 
                    if(item.period==2){
                      this.TemplateInfo.periodList2.push(item);
                    }
                    if(item.period==3){
                      this.TemplateInfo.periodList3.push(item);
                    }
                    if(item.period==4){
                      this.TemplateInfo.periodList4.push(item); 
                    }
                  })
                  // console.log(this.TemplateInfo);
                } 
            }) 
          },
          openAdd() {
            this.e_title = '新增模板';
            this.isUpdate = false;
            this.drawer = true; 
            this.paramRules = [];
            this.TemplateData.name = '';
            this.TemplateData.type = 1;
            this.TemplateData.usage = 1;
            this.TemplateData.unityPrice.electricityPrice = '';
            this.TemplateData.unityPrice.servicePrice = '';
            this.TemplateData.rules.forEach(item => {
              item.electricityPrice = '';
              item.servicePrice = '';
              item.beginTime = '';
              item.endTime = '';
            })
            this.$nextTick(() => {
              this.$refs.templateFormRef?.clearValidate();
            });
          },
          changeType(val){
            // 模板类型切换
            if(val=='1'){
              // 切换到全天统一价时，清空各时段的价格
              this.TemplateData.rules.forEach(item => {
                item.electricityPrice = '';
                item.servicePrice = '';
              });
            } else {
              // 切换到分段计费时，清空统一价格
              this.TemplateData.unityPrice.electricityPrice = '';
              this.TemplateData.unityPrice.servicePrice = '';
            } 
          },
          closeAdd() {
            this.$confirm('此操作不会保存更改哦，确定关闭吗？',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            })
              .then(_ => {
                this.drawer = false;
              })
              .catch(_ => {});
          },
          handleClose(done) {
            this.$confirm('此操作不会保存更改哦，确定关闭吗？',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            })
              .then(_ => {
                done();
              })
              .catch(_ => {});
          },
          check24HourCoverage(rules) {
            // 校验时段是否覆盖24小时（考虑秒级精度，留出容差空间）
            const timeToSeconds = (timeStr) => {
              const parts = timeStr.split(':');
              return parseInt(parts[0]) * 3600 + parseInt(parts[1]) * 60 + (parseInt(parts[2]) || 0);
            };
            
            // 创建24小时的覆盖数组（以秒为单位）
            const coverage = new Array(86400).fill(false);
            
            for (let rule of rules) {
              const startSeconds = timeToSeconds(rule.beginTime);
              let endSeconds = timeToSeconds(rule.endTime);
              
              // 如果结束时间是59秒，向上取整到下一分钟，留出容差空间
              const endSecondPart = parseInt(rule.endTime.split(':')[2]) || 0;
              if (endSecondPart >= 59) {
                endSeconds += 1; // 加1秒容差
              }
              
              // 标记覆盖的时间段
              for (let i = startSeconds; i < endSeconds && i < 86400; i++) {
                coverage[i] = true;
              }
            }
            
            // 检查是否全部覆盖（允许最后1秒的容差）
            const uncoveredCount = coverage.filter(covered => !covered).length;
            return uncoveredCount <= 1; // 允许最多1秒未覆盖
          },
          save(){
            // 保存
            let that = this;
            // 表单校验
            this.$refs.templateFormRef.validate((valid) => {
              if (!valid) return;
              
              // 校验价格合法性
              for(let i = 0; i < that.paramRules.length; i++){
                let item = that.paramRules[i];
                if(!/^\d+(\.\d+)?$/.test(item.electricityPrice)){
                  ElMessage.error('电价只能输入数字'); return;
                }
                if(!/^\d+(\.\d+)?$/.test(item.servicePrice)){
                  ElMessage.error('服务费只能输入数字'); return;
                }
              }
              
              //尖时可选，其他三个时段必须配置
              const hasPeriod2 = that.paramRules.some(r => r.period == 2);
              const hasPeriod3 = that.paramRules.some(r => r.period == 3);
              const hasPeriod4 = that.paramRules.some(r => r.period == 4);
              
              if(!hasPeriod2 || !hasPeriod3 || !hasPeriod4){
                ElMessage.error('峰时、平时、谷时必须配置'); return;
              }
              
              // 校验时段覆盖24小时
              if(!that.check24HourCoverage(that.paramRules)){
                ElMessage.error('配置的时段必须覆盖一天24小时'); return;
              }
              
              let param = {
                name: that.TemplateData.name,
                type: that.TemplateData.type,
                usage: that.TemplateData.usage,
                rules: that.paramRules,
              }
              if(that.isUpdate){
                param.id = that.TemplateData.id;
                var url = "platform-server/charge/template/edit";
              }else{
                var url = "platform-server/charge/template/add"; 
              }
              that.$axios.post(url,JSON.stringify(param)).then(result => {
                  if(result.code==200){
                      that.drawer = false;
                      ElMessage.success('保存成功');
                      if(!that.isUpdate){
                        that.currentPage = 1;
                      }
                      that.getList();
                  }
              })
            });
          },
          getList(){
              //获取列表
              let that = this;
              let param = {}; 
              param.page = that.currentPage;
              param.pageSize = that.pageSize;
              Object.keys(this.formInline).forEach(key => {
                  param[key] = this.formInline[key];
              });
              that.$axios.post("platform-server/charge/template/list",JSON.stringify(param)).then(result => {
                  if(result.code==200){
                      that.tableData = result.data.records;
                      that.total = result.data.total; 
                  }
              })
          }, 
          updateTemplate(index,row){
            //修改
            // console.log(row);
            this.e_title = '修改模板';
            this.isUpdate = true;
            this.drawer = true;
            let rowInfo = JSON.parse(JSON.stringify(row));
            this.paramRules = [];
            this.TemplateData.id = rowInfo.id;
            this.TemplateData.name = rowInfo.name;
            this.TemplateData.type = rowInfo.type;
            this.TemplateData.usage = rowInfo.usage;
            this.$axios.post("platform-server/charge/template/view/"+row.id).then(result => {
                if(result.code==200){
                  result.data.rules.forEach(item => {
                    if(item.period=='1'){
                      this.TemplateData.rules[0].electricityPrice = item.electricityPrice;
                      this.TemplateData.rules[0].servicePrice = item.servicePrice; 
                    }
                    if(item.period=='2'){
                      this.TemplateData.rules[1].electricityPrice = item.electricityPrice;
                      this.TemplateData.rules[1].servicePrice = item.servicePrice; 
                    }
                    if(item.period=='3'){
                      this.TemplateData.rules[2].electricityPrice = item.electricityPrice;
                      this.TemplateData.rules[2].servicePrice = item.servicePrice; 
                    }
                    if(item.period=='4'){
                      this.TemplateData.rules[3].electricityPrice = item.electricityPrice;
                      this.TemplateData.rules[3].servicePrice = item.servicePrice; 
                    }
                  });
                  // 如果是全天统一价类型，从第一个时段提取统一价格
                  if(rowInfo.type == 1 && result.data.rules.length > 0){
                    this.TemplateData.unityPrice.electricityPrice = result.data.rules[0].electricityPrice;
                    this.TemplateData.unityPrice.servicePrice = result.data.rules[0].servicePrice;
                  }
                  this.paramRules = result.data.rules; 
                }
            }) 
          },
          changeState(index,row){
            //删除
            this.$confirm('确定废弃该模板吗？',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            })
              .then(_ => {
                    this.$axios.post("platform-server/charge/template/disable/"+row.id).then(result => {
                        if(result.code==200){
                            this.getList(); 
                            ElMessage({
                                message: '操作成功',
                                type:'success',
                            })
                        }
                    })   
              }) 
        },
        },
        setup() {
         function periodFilter(period) {
            switch (period) {
              case 1:
                return '尖时';
              case 2:
                return '峰时';
              case 3:
                return '平时';
              case 4:
                return '谷时';
              default:
                return '';
            }
          } 
          function typeFilter(type) {
            switch (type) {
              case 1:
                return '全天统一价';
              case 2:
                return '分段计费';
              default:
                return '';
            }
          }
          function stateFilter(state) {
            switch (state) {
              case 1:
                return '正常';
              case 2:
                return '废弃';
              default:
                return '';
            }
          }
          function usageFilter(usage) {
            switch (usage) {
              case 1:
                return '公共模板';
              case 2:
                return '私有模板';
              default:
                return '';
            } 
          }
          return {
            periodFilter,
            typeFilter,
            stateFilter,
            usageFilter
          }; 
        }
    }
</script>
<style lang="scss" scoped>
.model_nav{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; 
  .model_item{
    width: 49%;
    margin-bottom: 20px;
    .item_nav{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 10px;
      color:#808080;
      .item_left{
        width: 47%;
        min-width: 300px;
        padding: 10px 1%;
        height: 150px;
        background-color: #f1f1f1;
        margin-bottom: 10px;
        margin-right: 10px;
        position: relative;
        .add_time_btn{
          width: 72px;
          position: absolute;
          margin: auto;
          top: 0;
          bottom: 0;
          right: 10px;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .item_right{
        width: 47%;
        min-width: 300px;
        padding: 10px 1%;
        height: 150px;
        background-color: #f1f1f1; 
        margin-bottom: 10px;
      }
    }
  }
}

.time-visualization{
  margin-top: 20px;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 4px;
  
  .viz-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    
    .viz-title{
      font-size: 16px;
      font-weight: bold;
      color: #303133;
    }
  }
  
  .time-blocks{
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    
    .time-block{
      flex: 1;
      height: 25px;
      margin: 0 1px;
      border: 1px solid #dcdfe6;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s;
      min-width: 0;
      
      .slot-label{
        font-size: 10px;
        color: #606266;
      }
      
      &.hour-period-1{
        background-color: #f56c6c;
        border-color: #f56c6c;
        
        .slot-label{
          color: #fff;
        }
      }
      
      &.hour-period-2{
        background-color: #e6a23c;
        border-color: #e6a23c;
        
        .slot-label{
          color: #fff;
        }
      }
      
      &.hour-period-3{
        background-color: #e6cf4c;
        border-color: #e6cf4c;
        
        .slot-label{
          color: #fff;
        }
      }
      
      &.hour-period-4{
        background-color: #67c23a;
        border-color: #67c23a;
        
        .hour-label{
          color: #fff;
        }
      }
      
      &.hour-unconfigured{
        background-color: #fff;
        
        .slot-label{
          color: #c0c4cc;
        }
      }
      
      &:hover{
        transform: scale(1.05);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      }
    }
  }
  
  .time-labels{
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    
    .hour-label-item{
      flex: 1;
      text-align: center;
      font-size: 11px;
      color: #909399;
    }
  }
  
  .time-legend{
    display: flex;
    justify-content: center;
    gap: 20px;
    
    .legend-item{
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 12px;
      color: #606266;
      
      .legend-color{
        width: 16px;
        height: 16px;
        border-radius: 2px;
        display: inline-block;
        
        &.legend-sharp{
          background-color: #f56c6c;
        }
        
        &.legend-peak{
          background-color: #e6a23c;
        }
        
        &.legend-flat{
          background-color: #e6cf4c;
        }
        
        &.legend-valley{
          background-color: #67c23a;
        }
        
        &.legend-unconfigured{
          background-color: #fff;
          border: 1px solid #dcdfe6;
        }
      }
    }
  }
}
</style>